// Action types
export const CHANGE_SELECTED_FEATURE = 'change_selected_feature'


export const changeSelectedFeature = featureList => {
	let numberSorted = Math.floor(Math.random()*featureList.length)

  return {
    type: CHANGE_SELECTED_FEATURE,
    payload: featureList[numberSorted],
  }
}
